import { prop, path } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { COOKIE_SETTINGS_REDUCER } from 'js/store/constants';
import { storageService } from 'js/services/storage.service';

import * as helpers from '../../helpers';
import * as actions from './store/actions';

export const useSetInitialCookiesGroups = () => {
    const dispatch = useDispatch();
    const { cookieGroups } = useAppSelector(prop('cookiesConfiguration'));
    const storageCookieName = useSelector(path([COOKIE_SETTINGS_REDUCER, 'storageCookieName']));

    useEffectOnce(() => {
        const defaultCookiesGroups = helpers.parseCookiesGroups(cookieGroups);
        const storageCookiesGroups = storageService.local.getItem(storageCookieName) || {};
        const mergedGroups = helpers.prepareCookiesGroups(defaultCookiesGroups, storageCookiesGroups);

        storageService.local.setItem(storageCookieName, mergedGroups);
        dispatch(actions.setCookiesGroupsInitial(mergedGroups));
    }, [dispatch, cookieGroups, storageCookieName]);
};
